import { React, Component } from 'react'
import { IoIosArrowBack } from 'react-icons/io';
import { FaRegCopy } from "react-icons/fa";
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

import BoletoImage from './boleto.png'

class PaymentBoleto extends Component {
    constructor(props){
        super(props);

        this.state = {
            step: 3,
            tooltipText: 'Clique para copiar'
        }

        this.copyToClipboard = this.copyToClipboard.bind(this);
    }

    copyToClipboard(e){

        var input = document.getElementById("barcode");
        input.focus();
        input.select();
        document.execCommand('copy');
        
        this.setState({
            tooltipText: 'Copiado!'
        })

    }

    render(){
        return(
            <div>
                <Link to="/payment">
                    <div className="main-title">
                        <h2>Boleto Bancário</h2>
                        <p>Lorem ipsum dolor sit amet</p>
                        <IoIosArrowBack />
                    </div>
                </Link>

                <div className="mt-4">

                    <img className="img-fluid w-100 mb-4" src={BoletoImage} />                

                    <div data-for="barCodeTip" data-tip onClick={(e) => this.copyToClipboard(e)} className="barcode">
                        <p>210210210921902109210929021092</p>
                        <input id="barcode" value="210210210921902109210929021092" />
                        <FaRegCopy  />
                    </div>
                    <ReactTooltip id="barCodeTip" getContent={() => this.state.tooltipText} />

                    <p className="text-center">
                        <small>
                            seu boleto foi enviado para<br />
                            <a href="mailto:mail@to.com.br" class="link-default">mailto@mailto.com.br</a><br />
                            e estará disponívela para pagamento até dia <br />
                            <strong>05/08/2021</strong>
                        </small>
                    </p>

                    <div className="row justify-content-center">
                        <a className="btn-default" href="#">Baixar PDF</a>
                    </div>
                </div>
            </div>
        )
    }
}
export default PaymentBoleto